import { IAppState } from '../../redux';
import { TOfferCategory } from '../../types/reducers/offer';

export function selectOfferCategory(state: IAppState): TOfferCategory {
  return state.offer.category;
}
